import { FormConfig } from 'stories/forms/FormBuilder/formBuilder.types';
import { NeedActionFormBody } from './components/NeedActionFormBody';
import type { NeedActionFormBodyProps } from './components/NeedActionFormBody';
import { ActionFormValues } from './components/useNeedActionFormtypes';

interface UseAddActionFormConfigProps
  extends Omit<NeedActionFormBodyProps, 'confirmDelete' | 'issueKey'> {
  issue: { key: string };
  confirmDeleteResource: NeedActionFormBodyProps['confirmDelete'];
}

/**
 * Builds the dialog form config around the shared need-action body.
 *
 * @param props - Form control bindings and resource-referral handlers.
 * @returns FormBuilder configuration for the add-action dialog.
 */
export const useAddActionFormConfig = ({
  issue,
  confirmDeleteResource,
  ...formBodyProps
}: UseAddActionFormConfigProps): FormConfig<ActionFormValues> => {
  return [
    {
      type: 'passthrough',
      content: (
        <NeedActionFormBody
          {...formBodyProps}
          issueKey={issue.key}
          confirmDelete={confirmDeleteResource}
        />
      ),
    },
  ] as FormConfig<ActionFormValues>;
};
